<template>
  <span>
    <span v-if="isBlank" class="text-black-50">--</span>
    <slot v-else></slot>
  </span>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    props: {
      isBlank: {
        type: Boolean,
        required: true,
      }
    },
  });
</script>